export default "__VITE_ASSET__48f898de__"